import { useState } from "react";
import { useNavigate } from "react-router-dom";

import LoadingGif from "../../../assets/images/Spin_loader.gif";
import BgImage from "../../../assets/images/Swipex_BG_image.jpg";
import TransparentBgImage from "../../../assets/images/Swipex_BG_Transparent_image.jpg";
import BackImage from "../../../assets/images/Swipex_Back_button.png";
import LogoutImage from "../../../assets/images/Swipex_Logout_button.png";
import BoxBG from "../../../assets/images/Swipex_BG_box.png";
import SwipexImage from "../../../assets/images/SWIPEX_2.0_Transparent.png";

import "./index.css";

import CreatePage from "../Create/create";
import StatusPage from "../Status/Status";
import ValidatorPage from "../Validator/validate";
import ApproverPage from "../Approver/Approve";

function Index() {

    const emailid = localStorage.getItem("emailid").toLocaleLowerCase();

    const Approver = ['rajeshkumar.v@switchmobilityev.com'];

  const formatName = (name) => {
    return (name || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
};

const CheckValues = (value) => {
    if (
        value == null ||
        value === "null" ||
        value === "NULL" ||
        value === "undefined" ||
        value === "UNDEFINED" ||
        value === ""
    ) {
        return "";
    }

    return value;
};

const userDetails = {
    EmpID: CheckValues(localStorage.getItem('empid')),
    EmpName: CheckValues(formatName(localStorage.getItem('empname'))),
    Location: CheckValues(localStorage.getItem('worklocation'))?.toLocaleUpperCase() || '',
    Department: CheckValues(localStorage.getItem('dept'))?.toLocaleUpperCase() || '',
    EmpEmail: CheckValues(localStorage.getItem('emailid'))?.toLocaleLowerCase() || '',
    ReportingManagerName: CheckValues(formatName(localStorage.getItem('reporting_managername'))),
    ReportingManagerEmail: CheckValues(localStorage.getItem('reporting_manageremail'))?.toLocaleLowerCase() || '',
};


    const navigate = useNavigate();

    const redirectTodashboard = () => {
        navigate("/landingPage");
    };

    const redirectToLogin = () => {
        navigate("/login");
    };

    const [activeTab, setActiveTab] = useState("create");
    const [loading, setLoading] = useState(false);

    const showCreate = () => {
        setActiveTab("create");
    };

    const showStatus = () => {
        setActiveTab("status");
    };

    const showValidator = () => {
        setActiveTab("validator");
    };

    const showApprover = () => {
        setActiveTab("approver");
    };

    const switchToStatusTab = () => {
        setActiveTab("status");
    };

    // USER 
    const [activeStatusTab, setActiveStatusTab] = useState("usersubmitted");

    const UserAll = () => {
        setActiveStatusTab("userall")
    }
    const UserSubmitted = () => {
        setActiveStatusTab("usersubmitted")
    };
    const UserUpdates = () => {
        setActiveStatusTab("userupdates")
    };
    const UserAccepted = () => {
        setActiveStatusTab("useraccepted")
    };
    const UserRejected = () => {
        setActiveStatusTab("userrejected")
    };

    // VALIDATOR 
    const [activeValidatorTab, setActiveValidatorTab] = useState("validatorsubmitted");

    const ValidatorAll = () => {
        setActiveValidatorTab("validatorall");
    }
    const ValidatorSubmitted = () => {
        setActiveValidatorTab("validatorsubmitted")
    };
    const ValidatorUpdates = () => {
        setActiveValidatorTab("validatorupdates")
    }
    const ValidatorAccepted = () => {
        setActiveValidatorTab("validatoraccepted")
    };
    const ValidatorRejected = () => {
        setActiveValidatorTab("validatorrejected")
    }

    // APPROVER 
    const [activeApproverTab, setActiveApproverTab] = useState("approversubmitted");

    const ApproverAll = () => {
        setActiveApproverTab("approverall");
    }
    const ApproverSubmitted = () => {
        setActiveApproverTab("approversubmitted")
    };
    const ApproverUpdates = () => {
        setActiveApproverTab("approverupdates")
    }
    const ApproverAccepted = () => {
        setActiveApproverTab("approveraccepted")
    };
    const ApproverRejected = () => {
        setActiveApproverTab("approverrejected")
    }
    const ApproverTrack = () => {
        setActiveApproverTab("approvertrack")
    }

    const Separator = () => (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignSelf: "stretch",
                margin: "0 8px",
                color: "#fff",
                fontSize: "5px",
                fontWeight: "900",
                lineHeight: "1px",
            }}
        >
            {Array.from({ length: 12 }).map((_, i) => (
                <span key={i}>•</span>
            ))}
        </div>
    );

    const tabStyle = (tab) => ({
        cursor: "pointer",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "3px",
        paddingBottom: "3px",
        margin: "2px",
        borderRadius: "4px",
        backgroundColor: activeTab === tab ? "#fff" : "transparent",
        color: activeTab === tab ? "#0d6efd" : "#fff",
        fontWeight: activeTab === tab ? "900" : "bold",
        fontFamily: "Aptos, 'Aptos Body', sans-serif",
        fontStyle: "italic",
        transition: "all 0.6s ease",
    });

    const glassTab = {
        background: "linear-gradient(145deg, rgba(255,255,255,0.25), rgba(255,255,255,0.08))",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid rgba(255,255,255,0.3)",
        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
        borderRadius: "25px",
        color: "white"
    };

    return (

        <>

            <div style={{
                backgroundImage: `url(${BgImage})`,
                minHeight: "100vh",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}>

                {/* HEADER */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className="p-2">

                    <div>
                        <img src={BackImage} className="rounded" style={{ width: "70px", height: "70px", cursor: "pointer" }} onClick={redirectTodashboard} />
                    </div>

                    <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "400px", height: "75px", borderRadius: "10px" }}>
                        <img src={SwipexImage} alt="Swipex" style={{ height: "70px", objectFit: "contain", }} />
                    </div>

                    <div>
                        <img src={LogoutImage} className="rounded" style={{ width: "70px", height: "70px", cursor: "pointer" }} onClick={redirectToLogin} />
                    </div>

                </div>

                {/* NAVBARS */}
                <div className="d-flex justify-content-center mb-1 mt-2">
                    <div style={{ width: "auto", maxWidth: "600px" }}>
                        <div
                            style={{
                                backgroundColor: "#0d6efd",
                                borderRadius: "8px",
                                padding: "4px",
                                display: "flex",
                                alignItems: "stretch",
                                justifyContent: "center",
                                fontSize: "13px",
                            }}
                        >
                            <span
                                style={tabStyle("create")}
                                onClick={showCreate}
                            >
                                CREATE
                            </span>

                            <Separator />

                            <span
                                style={tabStyle("status")}
                                onClick={showStatus}
                            >
                                STATUS
                            </span>

                            <Separator />

                            <span
                                style={tabStyle("validator")}
                                onClick={showValidator}
                            >
                                VALIDATOR
                            </span>

                            {Approver.includes(emailid) && (
                                <>
                                    <Separator />

                                    <span
                                        style={tabStyle("approver")}
                                        onClick={showApprover}
                                    >
                                        APPROVER
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* BORDER */}
                <div
                    style={{
                        width: "100%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        lineHeight: 1,
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "lightgray"
                    }}
                >
                    {"+ - ".repeat(1000)}
                </div>

                {/* USER */}

                {activeTab === "status" &&
                    <>
                        <div style={{ fontSize: "11px" }}>
                            <ul className="nav nav-pills mb-1 gap-2 mt-1 ms-1" style={{ borderRadius: "5px", }} >


                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeStatusTab === "userall"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={UserAll}
                                    >
                                        ALL
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }} >
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeStatusTab === "usersubmitted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={UserSubmitted}
                                    >
                                        SUBMITTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeStatusTab === "userupdates"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={UserUpdates}
                                    >
                                        UPDATES
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeStatusTab === "useraccepted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={UserAccepted}
                                    >
                                        ACCEPTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeStatusTab === "userrejected"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={UserRejected}
                                    >
                                        REJECTED
                                    </button>
                                </li>

                            </ul>
                        </div>

                        <div
                            style={{
                                width: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                lineHeight: 1,
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "lightgray"
                            }}
                        >
                            {"+ - ".repeat(1000)}
                        </div>
                    </>
                }

                {activeTab === "validator" &&
                    <>
                        <div style={{ fontSize: "11px" }}>
                            <ul className="nav nav-pills mb-1 gap-2 mt-1 ms-1" style={{ borderRadius: "5px", }} >


                                <li className="nav-item" style={{ borderRadius: "5px" }} >
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeValidatorTab === "validatorall"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ValidatorAll}
                                    >
                                        ALL
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }} >
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeValidatorTab === "validatorsubmitted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ValidatorSubmitted}
                                    >
                                        SUBMITTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeValidatorTab === "validatorupdates"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ValidatorUpdates}
                                    >
                                        UPDATES
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeValidatorTab === "validatoraccepted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ValidatorAccepted}
                                    >
                                        ACCEPTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeValidatorTab === "validatorrejected"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ValidatorRejected}
                                    >
                                        REJECTED
                                    </button>
                                </li>

                            </ul>
                        </div>

                        <div
                            style={{
                                width: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                lineHeight: 1,
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "lightgray"
                            }}
                        >
                            {"+ - ".repeat(1000)}
                        </div>
                    </>
                }

                {activeTab === "approver" &&
                    <>
                        <div style={{ fontSize: "11px" }}>
                            <ul className="nav nav-pills mb-1 gap-2 mt-1 ms-1" style={{ borderRadius: "5px", }} >


                                <li className="nav-item" style={{ borderRadius: "5px" }} >
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeApproverTab === "approverall"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ApproverAll}
                                    >
                                        ALL
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }} >
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeApproverTab === "approversubmitted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ApproverSubmitted}
                                    >
                                        SUBMITTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeApproverTab === "approveraccepted"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ApproverAccepted}
                                    >
                                        ACCEPTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeApproverTab === "approverrejected"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ApproverRejected}
                                    >
                                        REJECTED
                                    </button>
                                </li>

                                <li className="nav-item" style={{ borderRadius: "5px" }}>
                                    <button
                                        className="nav-link fw-bold border-0"
                                        style={
                                            activeApproverTab === "approvertrack"
                                                ? {
                                                    backgroundColor: "white",
                                                    color: "blue",
                                                    borderRadius: "25px"
                                                }
                                                : glassTab
                                        }
                                        onClick={ApproverTrack}
                                    >
                                        TRACK
                                    </button>
                                </li>

                            </ul>
                        </div>

                        <div
                            style={{
                                width: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                lineHeight: 1,
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "lightgray"
                            }}
                        >
                            {"+ - ".repeat(1000)}
                        </div>
                    </>
                }





                {/* ********************************************************************* */}
                {/* CONTENTS */}

                <div style={{ zIndex: "999" }}>

                    {/* CREATE TAB */}

                    {activeTab === "create" && <div className="fade-container">
                        <CreatePage setParentLoading={setLoading} switchToStatusTab={switchToStatusTab} userDetails={userDetails} />
                    </div>
                    }

                    {/* STATUS TAB */}

                    {activeTab === "status" && <StatusPage setParentLoading={setLoading} activeStatusTab={activeStatusTab} userDetails={userDetails} />}


                    {/* VALIDATOR TAB */}

                    {activeTab === "validator" && <ValidatorPage setParentLoading={setLoading} activeValidatorTab={activeValidatorTab} userDetails={userDetails} />}


                    {/* APPROVER TAB */}

                    {activeTab === "approver" && <ApproverPage setParentLoading={setLoading} activeApproverTab={activeApproverTab} userDetails={userDetails} />}


                </div>





            </div>


            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100vh",
                        width: "100vw",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <img
                        src={LoadingGif}
                        alt="Loading"
                        style={{ width: "150px", height: "150px" }}
                    />
                </div>
            )}

        </>

    )
}


export default Index;




